export enum AgreementStatusEnum {
  No_quote = 'no-quote',
  No_agreement = 'no-agreement',
  Draft = 'draft',
  Out_for_signature = 'out-for-signature',
  Signed = 'signed',
}
